<app-dialog-heading [heading]="heading"></app-dialog-heading>
<div class="dialog-container">
  <section [innerHTML]="html"></section>
</div>
<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button-fit-content" mat-raised-button color="warn" (click)="onClickCancel()">Close</button>
  <ng-container *ngIf="reportFileName">
    <button class="dialog-button-fit-content" mat-raised-button color="primary" (click)="onClickGenerate()">
      Download
    </button>
  </ng-container>
</mat-dialog-actions>